import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GoNavigationComponent } from '../shared/components/go-navigation/go-navigation.component';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-go-fees',
    imports: [GoNavigationComponent],
    templateUrl: './go-fees.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./go-fees.component.scss'],
})
export class GoFeesComponent {
    externalLinks = ExternalLinks;
}
